module.exports = __webpack_public_path__ + "static/media/florian_rival.dab04418.jpg";